import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { AuthButton, AuthCard, AuthField, AuthLinkRow, AuthNotice } from "./AuthCard";
import { checkResetLink, setNewPassword } from "@/api/passwordReset";

type Stage = "checking" | "invalid" | "form" | "done";

export const ResetPassword = () => {
  const { token = "" } = useParams();
  const [stage, setStage] = useState<Stage>("checking");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    checkResetLink(token).then((result) => {
      if (result.statusCode === 200) {
        setName(result.response?.name || "");
        setStage("form");
      } else {
        setMessage(result.message);
        setStage("invalid");
      }
    });
  }, [token]);

  const handleSubmit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    setError("");
    if (password !== confirm) return setError("The two passwords don't match.");
    setIsLoading(true);
    const result = await setNewPassword(token, password);
    setIsLoading(false);
    if (result.statusCode === 200) {
      setMessage(result.message);
      setStage("done");
    } else {
      setError(result.message);
    }
  };

  return (
    <AuthCard title={name ? `Choose a new password, ${name}` : "Choose a new password"}>
      {stage === "checking" && <p className="ac-sub">Checking your link...</p>}

      {stage === "invalid" && (
        <>
          <AuthNotice tone="error">{message}</AuthNotice>
          <AuthLinkRow>
            <Link to="/forgot-password">Request a new link</Link>
          </AuthLinkRow>
        </>
      )}

      {stage === "done" && (
        <>
          <AuthNotice tone="info">{message}</AuthNotice>
          <AuthLinkRow>
            <Link to="/login">Sign in</Link>
          </AuthLinkRow>
        </>
      )}

      {stage === "form" && (
        <form onSubmit={handleSubmit} noValidate>
          <AuthField label="New password" type="password" placeholder="New password" autoComplete="new-password" value={password} onChange={setPassword} />
          <AuthField label="Confirm password" type="password" placeholder="Confirm new password" autoComplete="new-password" value={confirm} onChange={setConfirm} />
          <p className="ac-hint">At least 8 characters.</p>
          {error && <AuthNotice tone="error">{error}</AuthNotice>}
          <AuthButton busy={isLoading} busyLabel="Saving...">Save new password</AuthButton>
        </form>
      )}
    </AuthCard>
  );
};

export default ResetPassword;
